import { deadlineSettingSchema, organizationSettingsSchema } from '@ghp/domain';
import { z } from 'zod';
import { bearer } from './http.js';
/**
 * Les réglages de l'organisation — l'écran « Réglages » du back-office. Ouverts au bureau côté
 * serveur (`@Roles('back_office', 'admin')` sur la classe du contrôleur) ; rien ici ne le rejoue,
 * un filtre de plus dans le navigateur ne protégerait que l'affichage.
 *
 * ⚠️ **`/settings/organization`, et non `/settings`.** Les notifications et les préférences
 * d'affichage de la maquette appartiennent au compte connecté, pas à l'organisation : elles
 * viendront sous leur propre chemin, avec leur propre stockage.
 *
 * ⚠️ **Ni `create` ni `remove`** : l'organisation est un singleton. `get` rend les défauts tant
 * que rien n'a été enregistré — pas un `404` —, et c'est `update` qui écrit la ligne au premier
 * passage.
 */
export function createSettingsEndpoints(http) {
    return {
        /**
         * `200` : les réglages, **toujours complets**. Une organisation jamais paramétrée rend ses
         * défauts, ce que l'écran affiche comme un formulaire vierge.
         */
        get(accessToken) {
            return http.get('/settings/organization', organizationSettingsSchema, bearer(accessToken));
        },
        /**
         * `200` : les réglages entiers après fusion — l'écran n'envoie que **ce qui a changé**, le
         * serveur rend l'état complet, et c'est lui qui repeuple le formulaire.
         *
         * ⚠️ **Vider un champ s'écrit `null`, jamais `''`** : le contrat refuse la chaîne vide, qui
         * s'imprimerait comme une valeur renseignée sur un cartouche.
         *
         * ⚠️ **Un `400` porte un message à afficher tel quel** : un contact référent réduit à une
         * adresse e-mail est refusé — la personne derrière n'aurait pas de nom.
         */
        update(accessToken, patch) {
            return http.patchJson('/settings/organization', patch, organizationSettingsSchema, bearer(accessToken));
        },
        /** Les délais de relance réglés par GHP : le défaut d'abord, puis l'écart de chaque secteur. */
        deadlines(accessToken) {
            return http.get('/settings/deadlines', z.array(deadlineSettingSchema), bearer(accessToken));
        },
        /** Remplace les délais d'une portée — le défaut ou un secteur —, et rend la liste entière. */
        replaceDeadlines(accessToken, input) {
            return http.putJson('/settings/deadlines', input, z.array(deadlineSettingSchema), bearer(accessToken));
        },
    };
}
//# sourceMappingURL=settings.js.map